import awsmobile from './amplifyconfiguration.json';

export const awsConfig = {
    awsmobile,
    restApi: {
        name: 'cexnewsletterrest'
    }
};
